export function formatIndianNumber(num:string) {
  if (!num) return 0
    const str = num.toString().split('.');
    let integerPart = str[0];
    const decimalPart = str.length > 1 ? '.' + str : '';
  
    let lastThree = integerPart.slice(-3);
    let otherNumbers = integerPart.slice(0, -3);
  
    if (otherNumbers !== '') {
      lastThree = ',' + lastThree;
    }
  
    const result =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + decimalPart;
  
    return result;
  }
  